import React from 'react'
import { compose, withState } from 'recompose'
import { Dropdown } from 'semantic-ui-react'

const SelectInputWithStampNull = (props) => {
  const { 
    label, 
    placeHolder, 
    input, 
    require, 
    requireLabel=null,
    editable=true,
    loading, 
    multiple,
    noBorder,
    allowAdditions, 
    onAddNewItem,
    specialOnChange, 
    options=[], 
    ignoreClearValue, 
    specialOnSearchChange,
    specialOnClose,
    underLabel=null,
    searchQuery, 
    setSearchQuery, 
    beforeOnChange, 
    noResultsMessage, 
    useLazyLoad=false, 
    style, 
    meta: { touched, error } 
  } = props

  const [searchKey, setSearchKey] = React.useState(0)
  const [dataAdded, setDataAdded] = React.useState('')
// เพิ่ม select ที่ clear ค่าได้ถ้า map data ไม่เจอ เกิดจาก case procurement map user ไม่เจอเพราะ user ลาออกเลยไม่มีค่าส่งมา
  React.useEffect(() => {
  if (!options || options.length === 0) return
  if (!input.value) return

  const exists = options.some(x => x.value === input.value)

  if (!exists) {
    input.onChange(null)
  }
}, [options]) 

  const getDataOption = React.useMemo(() => {
    if(!useLazyLoad) return ()=>options
    return ()=>{
      if(options.length>0){
        if(searchKey==''){
          let data = options.filter((x,i)=>i<50)
          if(input.value){
            if(!data.find((x)=>x.value==input.value)){
              let i = options.find((x)=>x.value==input.value)
              if(i!=null) data.push(i)
            }
          }
          return [...data,{
            key:dataAdded,
            value:dataAdded,
            text:dataAdded,
          }]
        }
        else{
          let searchResult = options.filter((x)=>x.text.includes(searchKey))
          let dataFilter = searchResult.filter((x,i)=>i<50)
          return [...dataFilter,{
            key:dataAdded,
            value:dataAdded,
            text:dataAdded,
          }]
        }
      }
    }
  }, [searchKey,options,input.value,dataAdded])

  return (
    <div className='fieldRow' style={{...style}}>
      <span className='fieldLabel'>
        {label}
        {require ? <span className='require'>* {requireLabel}</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
        <span style={{float: 'right'}}>{props.showPODetail != undefined ? props.showPODetail(): null}</span>
      </span>
      
      <div className={`fieldInput ${editable!==false?'editableSelectInput':'disableSelectInput'} ${noBorder?'selectInputNoBorder':''}`}>
        <Dropdown
          name={input.name}
          fluid
          search
          selection
          selectOnBlur={false}
          clearable={editable && !ignoreClearValue}
          disabled={editable === false}
          placeholder={placeHolder}
          additionPosition='bottom'
          error={touched && error}
          value={input.value}
          options={getDataOption()}
          multiple={multiple !== undefined ? multiple : false}
          allowAdditions={allowAdditions !== undefined ? allowAdditions : false}
          loading={loading !== undefined ? loading : false}
          noResultsMessage={noResultsMessage ? noResultsMessage : 'No results found.'}
          onChange={(e, data) => {
            setSearchKey(data.value)
            if (beforeOnChange) {
              beforeOnChange({
                value: data.value,
                onChange: () => {
                  input.onChange(data.value)
                  setSearchQuery('')
                },
                specialOnChange: specialOnChange ? () => specialOnChange(data.value) : null,
                clearSearchText: () => setSearchQuery('')
              })
            } else {
              input.onChange(data.value)
              setSearchQuery('')
              if (specialOnChange) {
                specialOnChange(data.value)
              }
            }
          }}
          onClose={(e, data) => {
            setSearchQuery('')
            setSearchKey('')
            if (specialOnClose) {
              specialOnClose(data)
            }
          }}
          onAddItem={(e, data) => {
            if(onAddNewItem){
              onAddNewItem(data.value)
            }else{
              setDataAdded(data.value)
            }
          }}
          searchQuery={searchQuery}
          onSearchChange={(e, data) => {
            setSearchKey(data.searchQuery)
            if (searchQuery !== data.searchQuery.trimLeft()) {
              setSearchQuery(data.searchQuery.trimLeft())
              data.searchQuery = data.searchQuery.trim()
              if (specialOnSearchChange) {
                specialOnSearchChange(data.searchQuery)
              }
            }
          }}
        />
      </div>
      {underLabel?<span className='fieldLabel'>
        {underLabel}
      </span>:null}
    </div>
  )
}

export default compose(
  withState('searchQuery', 'setSearchQuery', '')
)(SelectInputWithStampNull)
